import React from 'react';

const ContactSection = () => {
  return (
    <>
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
        <div className="auto-container">
          <div className="content-box">

            <h1>Contact Us</h1>
          </div>
        </div>
      </section>


      <div className="contact-section text-center">

        <section className="elementor-section elementor-top-section elementor-section-boxed elementor-section-height-default row-top py-4">
          <div className="elementor-container elementor-column-gap-default">


            <div className="elementor-column elementor-col-33 elementor-top-column borderr">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-widget-container">
                  <div className="elementor-icon-box-wrapper">
                    <div className="elementor-icon-box-icon">
                      <a href="tel:6668880000" className="elementor-icon" aria-label="Phone">
                        <i className="fas fa-phone-alt"></i>
                      </a>
                    </div>
                    <div className="elementor-icon-box-content">
                      <h3 className="elementor-icon-box-title"><a href="tel:6668880000">Phone</a></h3>
                      <p className="elementor-icon-box-description"><a className="body-color" href="tel:919075462128">+91 9075462128</a></p>
                      <p className="elementor-icon-box-description"><a className="body-color" href="tel:918452916550">+91 8452916550</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="elementor-column elementor-col-33 elementor-top-column borderr">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-widget-container">
                  <div className="elementor-icon-box-wrapper">
                    <div className="elementor-icon-box-icon">
                      <a href="mailto:contact@example.com" className="elementor-icon" aria-label="Email">
                        <i className="fas fa-envelope"></i>
                      </a>
                    </div>
                    <div className="elementor-icon-box-content">
                      <h3 className="elementor-icon-box-title"><a href="mailto:contact@example.com">Email</a></h3>
                      <p className="elementor-icon-box-description"><a className="body-color" href="mailto:booking@meghanacabs.com">booking@meghanacabs.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="elementor-column elementor-col-33 elementor-top-column borderr">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-widget-container">
                  <div className="elementor-icon-box-wrapper">
                    <div className="elementor-icon-box-icon">
                      <span className="elementor-icon"><i className="fas fa-map-marker-alt"></i></span>
                    </div>
                    <div className="elementor-icon-box-content">
                      <h3 className="elementor-icon-box-title"><span>Address</span></h3>
                      <h3 className="elementor-icon-box-title"><span>Meghana Cabs</span></h3>

                      <p className="elementor-icon-box-description">
                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>


        <section className="contact-map-section">
          <div className="auto-container">
            <div className="map-inner">

              <iframe
                title="VITTHAL LAWNS Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d191274.59078508636!2d73.54126778542445!3d18.602161008472436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bbd7a20f8d2b%3A0xddacb017733d7044!2sVITTHAL%20LAWNS%2C%20Mayuri%20Regency%2C%20Laxmi%20Chowk%20Rd%2C%20Bhumkar%20Nagar%2C%20Wakad%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411057!5e1!3m2!1sen!2sin!4v1749903002944!5m2!1sen!2sin"
                width="100%"
                height="450"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />



            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default ContactSection;
